import { Sk } from './shared';

const CITES = [
  { ix: '[1]', src: 'Dynamics CRM', meta: 'Tarif-08' },
  { ix: '[2]', src: 'SharePoint',   meta: 'Richtlinie.pdf' },
  { ix: '[3]', src: 'EnWG',         meta: '§ 14a' },
];

export function MkKB() {
  return (
    <div className="csmk csmk-kb">
      <div className="query">
        <span className="mag" />
        <span className="qtext">Welche Förderung gilt für PV-Speicher?</span>
        <span className="ret">↵</span>
      </div>
      <div className="answer">
        <span className="lbl">Answer</span>
        {(['94%', '100%', '78%'] as const).map((w, i) => <Sk key={i} w={w} h="6px" />)}
      </div>
      <div className="sources">
        <span className="shd">Sources · 3</span>
        {CITES.map((c) => (
          <div className="cite" key={c.ix}>
            <span className="ix">{c.ix}</span>
            <span className="doc" />
            <span className="src">{c.src}</span>
            <span className="meta">{c.meta}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
